import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styles from './Logo.scss';

import { setScrollTop } from 'actions/objects';

class Logo extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    const { dispatch, history } = this.props;
    history.push(sessionStorage.getItem('filtersUrl') || this.props.to || '/');
    dispatch(setScrollTop(null));
  }

  render() {
    const { className, nolink, to = '/' } = this.props;

    return (
        nolink ? (
          <div className={className}>
            <div className={styles.Logo}>
              <img alt="logo" src={require('assets/images/logo.svg')} />
            </div>
          </div>
        ) : (
          <a href={to} className={className} onClick={this.handleClick}>
            <div className={styles.Logo}>
              <img alt="logo" src={require('assets/images/logo.svg')} />
            </div>
          </a>
        )
    );
  }
}

export default connect(state => state.search)(
  withRouter(Logo)
);



// WEBPACK FOOTER //
// ./src/components/Header/Logo/Logo.js